import axios from "axios";
import { API_BASE_URL } from "../../../config";


export const getHomeUserList = async (homeUserId) =>
{
    try
    {
        const response = await axios.get(`${API_BASE_URL}/api/Chat/HomeUserConversationList`, {
            params: {
                homeUserId,
            },
        });
        return response.data;
    } catch (error)
    {
        console.error("Error fetching conversation list:", error);
        throw error;
    }
};
